// REACT
import React, { useContext, useEffect, RefObject, useRef, MutableRefObject } from 'react'

// ROUTER
import { Link, withRouter, RouteComponentProps } from 'react-router-dom'

// ESTILOS
import Styles from './Navbar.module.css'

// CONTEXTO
import MainContext from 'Context/MainContext'
import ShowBook from 'Components/showBook/ShowBook'

// PROPIEDADES
interface NavbarProps extends RouteComponentProps {
	changeLang: (mode: number) => any
}

const Navbar: React.FC<NavbarProps> = (props: NavbarProps) => {
	// CONTEXTO
	const { lang, langCode } = useContext(MainContext)
	const { navbar } = lang

	// REFERENCIAS
	const translateOptions: RefObject<HTMLUListElement> = useRef(null)
	const reservationBtn: RefObject<HTMLAnchorElement> = useRef(null)
	const showInp: RefObject<HTMLInputElement> = useRef(null)
	const nav: RefObject<HTMLElement> = useRef(null)
	const pagesRef: MutableRefObject<NodeListOf<HTMLDivElement> | null> = useRef(null)

	// PATH
	const path: string = props.history.location.pathname.substr(1)

	// OCULTAR SIDEBAR CUANDO CAMBIE LA RUTA
	useEffect(() => {
		if (showInp.current) showInp.current.checked = false

		// SELECCIONAR PAGINAS
		const pages: NodeListOf<HTMLDivElement> = document.querySelectorAll('.page')

		// GUARDAR PAGINAS
		pagesRef.current = pages
	}, [path])

	// HACER SCROLL EN PAGINA
	const links = navbar.routes.map((_route: string, index: number) => () => {
		// CAMBIAR RUTA
		if (path !== '') props.history.push('/')

		setTimeout(
			() => {
				// HACER SCROLL
				if (pagesRef.current && index < 4) {
					// OBTENER SCROLL
					const scroll: number = pagesRef.current[index > 0 ? index - 1 : 0].offsetTop - 113
					console.log(pagesRef.current)
					window.scrollTo({ top: scroll, behavior: 'smooth' })

					// OCULTAR
					if (showInp.current) showInp.current.checked = false
				}
			},
			path !== '' ? 500 : 0
		)
	})

	// ASIGNAR POLITICAS
	links[4] = () => {
		// OCULTAR
		if (showInp.current) showInp.current.checked = false

		// CAMBIAR RUTA
		props.history.push('/politicas')
	}

	links[2] = () => {
		// OCULTAR
		if (showInp.current) showInp.current.checked = false

		// CAMBIAR RUTA
		props.history.push('/habitaciones')
	}

	links[1] = () => {
		// OCULTAR
		if (showInp.current) showInp.current.checked = false

		// CAMBIAR RUTA
		props.history.push('/galeria')
	}

	// OCULTAR/MOSTRAR TRANSLATE
	const hideTranslate = () => {
		if (translateOptions.current)
			translateOptions.current.style.transform =
				window.innerWidth > 650 ? 'scale(0)' : 'translate(-50%) scale(0)'
	}
	const showTranslate = () => {
		if (translateOptions.current)
			translateOptions.current.style.transform =
				window.innerWidth > 650 ? 'scale(1)' : 'translate(-50%) scale(1)'
	}

	// CAMBIAR LENGUAJES
	const changeToEs = () => {
		props.changeLang(0)
		hideTranslate()
	}
	const changeToEn = () => {
		props.changeLang(1)
		hideTranslate()
	}
	const changeToFr = () => {
		props.changeLang(2)
		hideTranslate()
	}

	// CAMBIAR COLOR DE CTA
	const changeCTA = () => {
		if (reservationBtn.current) reservationBtn.current.style.background = 'transparent'
	}

	// SCROLL EFFECT
	useEffect(() => {
		// OCULTAR TRANSLATE
		window.addEventListener('click', (ev: MouseEvent) => {
			// ELEMENTO
			const el: HTMLElement = ev.target as HTMLElement

			// VERIFICAR
			if (translateOptions.current)
				if (
					!translateOptions.current.contains(el) &&
					!el.classList.contains('translateBtn') &&
					!el.classList.contains('lni-world')
				)
					hideTranslate()
		})

		// CAMBIAR ESTILOS DEL NAVBAR
		const updateScrollStyles = (y: number) => {
			// CAMBIAR NAV
			if (nav.current && reservationBtn.current) {
				nav.current.style.boxShadow = y > 30 ? '0 4px 4px rgba(0, 0, 0, 0.3)' : 'none'
				nav.current.style.background = y > 30 ? 'var(--blue)' : 'transparent'
				reservationBtn.current.style.background =
					y > 30
						? showInp.current?.checked
							? 'transparent'
							: 'rgba(50, 50, 50, .5)'
						: 'transparent'
			}
		}

		// CAMBIAR ESTILOS CUANDO SE HACE SCROLL
		window.addEventListener('scroll', () => {
			// OBTENER SCROLL
			const y: number = window.scrollY

			// ACTUALIZAR ESTILOS
			updateScrollStyles(y)
		})

		// CAMBIAR LA PRIMERA VEZ
		updateScrollStyles(window.scrollY)
	}, [])

	// SCROLL HACIA ARRIBA
	const goUp = () => {
		// SCROLL
		window.scrollTo({ top: 0, behavior: 'smooth' })

		// OCULTAR
		if (showInp.current) showInp.current.checked = false
	}

	return (
		<>
			<input type='checkbox' id='openMenuIn' ref={showInp} defaultChecked={false} />
			<div
				className={Styles.covid}
				id='covid'
				style={{
					top: path === 'reservaciones' ? '-50px' : '0px',
				}}>
				<span>{navbar.covid}</span>
				<ShowBook
					name={navbar.covidBtn}
					style={{
						color: 'white',
						marginLeft: '5px',
						fontWeight: 'bold',
						textDecoration: 'underline',
						fontFamily: 'RobotoC',
						cursor: 'pointer',
					}}
					type='covid'
				/>
			</div>
			<nav
				ref={nav}
				className={Styles.nav}
				style={
					path === ''
						? {
								background: 'transparent',
								boxShadow: 'none',
						  }
						: path === 'galeria'
						? {
								background: 'transparent',
								boxShadow: 'none',
						  }
						: path === 'reservaciones'
						? {
								transform: 'translateY(-100%)',
								top: '0px',
						  }
						: path === 'politicas'
						? {
								transform: 'translateY(-100%)',
								top: '0px',
						  }
						: undefined
				}>
				<div className={Styles.actions}>
					<label htmlFor='openMenuIn' className={Styles.menuBtn} onClick={changeCTA}>
						<span className={Styles.menuBtnItem} />
						<span className={Styles.menuBtnItem} />
						<span className={Styles.menuBtnItem} />
					</label>

					<Link to='/' title='Inicio' className={Styles.logo} onClick={goUp}>
						<img src='/images/logo.png' alt='Logo' />
					</Link>

					<button onClick={showTranslate} className={`${Styles.translateBtn} translateBtn`}>
						<i className={`${Styles.translateBtnIcon} lni lni-world`} />
						{langCode}
					</button>

					<ul className={Styles.translateOptions} ref={translateOptions}>
						<li>
							<button onClick={changeToEs}>
								<img src='https://www.countryflags.io/es/flat/24.png' alt='ES' />
								ES
							</button>
						</li>
						<li>
							<button onClick={changeToEn}>
								<img src='https://www.countryflags.io/us/flat/24.png' alt='EN' />
								EN
							</button>
						</li>
						<li>
							<button onClick={changeToFr}>
								<img src='https://www.countryflags.io/fr/flat/24.png' alt='FR' />
								FR
							</button>
						</li>
					</ul>
				</div>

				<div className={Styles.reservation}>
					<a
						className={`${Styles.waLink} waLink`}
						href='https://api.whatsapp.com/send?phone=50277612014&text=%C2%A1Hola!%20Me%20gustar%C3%ADa%20reservar%20una%20habitaci%C3%B3n%20en%20Villa%20de%20Don%20Andr%C3%A9s.'
						target='_blank'
						rel='noopener noreferrer'
						title='Whatsapp'>
						<i className={`${Styles.waLinkIcon} lni lni-whatsapp`} />
						+502 7761-2014
					</a>
					<Link
						ref={reservationBtn}
						style={
							path === ''
								? {
										background: 'transparent',
								  }
								: showInp.current?.checked
								? {
										background: 'transparent',
								  }
								: undefined
						}
						to='/reservaciones'
						title='Reservaciones'
						className={`${Styles.resLink} btn`}>
						<svg
							version='1.1'
							x='0px'
							y='0px'
							viewBox='0 0 477.867 477.867'
							fill='var(--iconColor)'>
							<g>
								<g>
									<path
										d='M426.667,51.2h-51.2V17.067C375.467,7.641,367.826,0,358.4,0s-17.067,7.641-17.067,17.067V51.2h-204.8V17.067
			C136.533,7.641,128.892,0,119.467,0S102.4,7.641,102.4,17.067V51.2H51.2C22.923,51.2,0,74.123,0,102.4v324.267
			c0,28.277,22.923,51.2,51.2,51.2h375.467c28.277,0,51.2-22.923,51.2-51.2V102.4C477.867,74.123,454.944,51.2,426.667,51.2z
			 M443.733,426.667c0,9.426-7.641,17.067-17.067,17.067H51.2c-9.426,0-17.067-7.641-17.067-17.067V204.8h409.6V426.667z
			 M443.733,170.667h-409.6V102.4c0-9.426,7.641-17.067,17.067-17.067h51.2v34.133c0,9.426,7.641,17.067,17.067,17.067
			s17.067-7.641,17.067-17.067V85.333h204.8v34.133c0,9.426,7.641,17.067,17.067,17.067s17.067-7.641,17.067-17.067V85.333h51.2
			c9.426,0,17.067,7.641,17.067,17.067V170.667z'
									/>
								</g>
							</g>
							<g>
								<g>
									<path
										d='M136.533,238.933H102.4c-9.426,0-17.067,7.641-17.067,17.067c0,9.426,7.641,17.067,17.067,17.067h34.133
			c9.426,0,17.067-7.641,17.067-17.067C153.6,246.574,145.959,238.933,136.533,238.933z'
									/>
								</g>
							</g>
							<g>
								<g>
									<path
										d='M256,238.933h-34.133c-9.426,0-17.067,7.641-17.067,17.067c0,9.426,7.641,17.067,17.067,17.067H256
			c9.426,0,17.067-7.641,17.067-17.067C273.067,246.574,265.426,238.933,256,238.933z'
									/>
								</g>
							</g>
							<g>
								<g>
									<path
										d='M375.467,238.933h-34.133c-9.426,0-17.067,7.641-17.067,17.067c0,9.426,7.641,17.067,17.067,17.067h34.133
			c9.426,0,17.067-7.641,17.067-17.067C392.533,246.574,384.892,238.933,375.467,238.933z'
									/>
								</g>
							</g>
							<g>
								<g>
									<path
										d='M136.533,307.2H102.4c-9.426,0-17.067,7.641-17.067,17.067c0,9.426,7.641,17.067,17.067,17.067h34.133
			c9.426,0,17.067-7.641,17.067-17.067C153.6,314.841,145.959,307.2,136.533,307.2z'
									/>
								</g>
							</g>
							<g>
								<g>
									<path
										d='M256,307.2h-34.133c-9.426,0-17.067,7.641-17.067,17.067c0,9.426,7.641,17.067,17.067,17.067H256
			c9.426,0,17.067-7.641,17.067-17.067C273.067,314.841,265.426,307.2,256,307.2z'
									/>
								</g>
							</g>
							<g>
								<g>
									<path
										d='M375.467,307.2h-34.133c-9.426,0-17.067,7.641-17.067,17.067c0,9.426,7.641,17.067,17.067,17.067h34.133
			c9.426,0,17.067-7.641,17.067-17.067C392.533,314.841,384.892,307.2,375.467,307.2z'
									/>
								</g>
							</g>
							<g>
								<g>
									<path
										d='M136.533,375.467H102.4c-9.426,0-17.067,7.641-17.067,17.067S92.974,409.6,102.4,409.6h34.133
			c9.426,0,17.067-7.641,17.067-17.067S145.959,375.467,136.533,375.467z'
									/>
								</g>
							</g>
							<g>
								<g>
									<path
										d='M256,375.467h-34.133c-9.426,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067H256
			c9.426,0,17.067-7.641,17.067-17.067S265.426,375.467,256,375.467z'
									/>
								</g>
							</g>
							<g>
								<g>
									<path
										d='M375.467,375.467h-34.133c-9.426,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h34.133
			c9.426,0,17.067-7.641,17.067-17.067S384.892,375.467,375.467,375.467z'
									/>
								</g>
							</g>
						</svg>
						{navbar.cta}
					</Link>
				</div>

				<div className={`${Styles.sideBar} sideBar`}>
					<ol className={Styles.sideBarList}>
						{navbar.routes.map((route: string, key: number) => (
							<li key={key} className={Styles.linkList} onClick={links[key]}>
								<button title={route} className={Styles.navlink}>
									<span className={Styles.navlinkIndex}>0{key + 1}.</span>
									{route}
								</button>
							</li>
						))}
					</ol>
				</div>
			</nav>
		</>
	)
}

export default withRouter(Navbar)
